<template>
  <div
    class="anz-post__header-author anz-flex anz-align-items-start anz-pr-s"
    data-cy="post-created-by"
  >
    <!-- Author name -->
    <div
      class="anz-fs-xs anz-mr-6 anz-text-break-all anz-post__username"
      v-if="configuration.widget.postUserLinkDisabled"
    >
      {{ author.nickname }}
    </div>
    <template v-else>
      <a-button
        add-href
        :href="generateProfileRoute(author)"
        :title="author.nickname"
        className="anz-link anz-fs-xs anz-mr-6 anz-text-break-all anz-post__username"
      />
    </template>
    <div>
      {{ author.settings }}
    </div>
    <template v-if="!showAuthorAbove">
      <a-premium v-if="author.isSubscriptionPremium && author.isShowPremium" />
      <template v-if="author.blog.link.length > 0 && !hideUserBlog">
        <div
          v-if="configuration.widget.postUserLinkDisabled"
          class="anz-badge anz-badge-gray anz-badge-sm anz-text-uppercase anz-mt-xxxs anz-mr-s"
        >
          {{ $translate('profile.labels.blogger') }}
        </div>
        <a-button
          v-else
          add-href
          :href="author.blog.link"
          :title="$translate('profile.labels.blogger')"
          target-blank
          className="anz-link anz-badge anz-badge-gray anz-badge-sm anz-text-uppercase anz-mt-xxxs anz-mr-s"
        />
      </template>
      <!-- New badge -->
      <template
        v-if="
          allowShowNew &&
            postRoot.post.postMeta.isNew &&
            !isMinePost &&
            !firstForumVisit
        "
      >
        <div
          class="anz-badge anz-badge-green anz-badge-sm anz-text-uppercase anz-mt-xxxs"
        >
          {{ $translate('profile.labels.new') }}
        </div>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import useAppState from '@/composables/ui/ui'
import { PostsRoot } from '@/composables/post/postList'
import useConfiguration from '@/composables/configuration/configuration'
import APremium from '@/components/Ui/Badge/Premium.vue'

export default defineComponent({
  name: 'PostAuthor',
  components: { APremium, AButton },
  props: {
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    showAuthorAbove: {
      type: Boolean,
      default: false,
    },
    allowShowNew: {
      type: Boolean,
      default: false,
    },
    isMinePost: {
      type: Boolean,
      default: false,
    },
    hideUserBlog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const author = props.postRoot.post?.author
    return {
      author,
      ...useConfiguration(),
      ...useRouter(),
      ...useAppState(),
    }
  },
})
</script>
